<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯优图斩获CVPR 2022 CLEAR Challenge持续学习重磅比赛第一名</div>
      <div class="news-date">2022年6月24日</div>
      <div class="news-content">
        <div class="image-panel">
          <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
        </div>
        <p>
          <span>近日，在 CVPR 2022 举办的CLEAR Challenge比赛中，</span>
          <span class="mark-text">腾讯优图实验室在CLEAR10和CLEAR100数据集赛道均取得了第一名的成绩[1]。</span>
        </p>
        <p>CVPR 2022 CLEAR比赛主要聚焦于在现实世界图像的持续学习(continual learning)，深入探讨现实生活中的图像数据，是CVPR 2022的重磅比赛之一，也是持续学习领域的一个权威赛事。</p>
        <p>随着时间的推移，现实中同一个实体的外观设计也会产生很大区别，这给图像识别带来了极大困难。例如，上世纪 90 年代的照相机的外观更接近老式的胶片相机，而近年来的照相机大多指代微单，二者形态差异很大。为了研究持续学习在现实图像中的应用，CLEAR 收集了不同实体在 2004 到 2014 年的网络图像，提出了基于时间流去做持续学习的新训练范式。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news16.png"/>
            <p>图1 CLEAR 数据集[2]</p>
          </div>
        </div>
        <p>
          具体来说，组织方把图片数据根据拍摄年份分为 10 个子集，比赛参与者则需要针对每个年份训练一个图片分类模型。为了模拟真实场景，每一个模型的训练只可以使用当前年份及以前的数据。比如 2010 年的相机识别模型可以使用过去的所有数据进行训练，但是不能用 2010 年以后的数据。这种基于时间流的训练范式更能模拟业务模型迭代的过程。此外，为了限制参赛者专注于解决这种时间流训练范式存在的问题，组织方严格限制了参赛者训练模型的时长，要求每个时间戳的模型在单卡的1080Ti训练时间不能超过12小时。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news16/news16_3.png"/>
            <p>图2 CLEAR 评测指标[1]</p>
          </div>
        </div>
        <p>在评测指标上，主要从 4 个维度评估模型。In-domain Accuracy 主要关注模型在当前时间戳的效果，Next-domain Accuracy 评估当前模型在下一个时间戳数据的泛化能力，Backward Transfer 考察当前模型在过去数据综合效果，Forward Transfer 综合评估了当前模型对未来数据的泛化能力。最终取这四个指标的平均值作为模型的评估效果。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news16/news16_2.png"/>
            <p>图3 基于 bucket的持续学习采样方案</p>
          </div>
        </div>
        <p>针对这种业界新颖的时间流训练范式，优图团队首先根据团队积累的算法能力，借助各种复杂而有效的数据增强技巧和训练策略，构建出一个高效的基线模型；然后，该团队采用累积式训练策略（cumulative training），即当前时间戳的模型会加载前一个时间戳模型的权重，同时当前时间戳的训练数据会加载该时间戳之前的全部训练数据。这种累积式的训练方式可以减少当前时间戳模型对过去数据的遗忘。借助这些技术，该团队在主办方提供的基线模型上效果提升幅度达到了 0.2 以上。</p>
        <p>但是，这种轮询式学习策略使得模型不断访问历史数据，极大程度增加了模型训练的时长，受到了比赛规定训练时间的约束。为了减少对历史数据的访问，优图团队设计了几种高效的数据采样策略，如按时间戳权重采样、均匀采样、重复采样或者按不同类别采样等。团队发现通过设置合适大小的存储单元对历史数据进行均匀重复的重放，即可高效完成对过去全部数据的轮询，从而极大减少了模型训练时间，提升模型性能。此外，团队还在模型上探索少样本数据从零学习的网络结构。通过改变模型卷积模块的下采样方式，在不增加参数量的前提下也可以有效降低模型对过去数据的遗忘，从而在近似相同的参数量下取得更好的性能。通过这些数据采样策略和模型设计，算法指标上突破 0.9，大幅度超过官方基线模型。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news16/news16_1.jpeg"/>
            <p>图4 CLEAR比赛最终排名[3]</p>
          </div>
        </div>
        <p>基于以上技术方案，腾讯优图在该赛道的CLEAR10和CLEAR100数据集上均取得第一的成果，且模型训练时长仅为官方限制时间的2/3。</p>
        <p>基于时间流的训练范式模拟了业务模型的迭代过程，具有重要的实践价值。未来，通过对时间流数据的持续学习，业务模型可以不必每次都进行冷启动训练，而是从历史模型中加载，从而大大降低模型迭代时长，达到降本增效的目的。</p>
        <div class="news-literature">
          <p>滑动查看参考文献</p>
          <div>
            <p>1.AIcrowd | CVPR 2022 CLEAR Challenge | Leaderboards；</p>
            <p>https://www.aicrowd.com/challenges/cvpr-2022-clear-challenge/leaderboards</p>
          </div>
          <p>2.Lin, Zhiqiu, et al. "The CLEAR Benchmark: Continual LEArning on Real-World Imagery." Thirty-fifth Conference on Neural Information Processing Systems Datasets and Benchmarks Track (Round 2). 2021.</p>
          <p>3.Workshop Visual Perception and Learning in an Open World in CVPR2022；https://www.youtube.com/watch?v=q4ypT-33puU&t=11551s</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News16',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    p {
      font-size: 12px;
      color: #858585;
    }
  }
  .paragraph-title {
    margin: auto;
    border-top: 1.5px #0152d9 solid ;
    p {
      text-align: center;
      color:#0152d9;
      font-size:17px;
    }
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News16.vue